import EventList, {IEventData} from "../EventList/EventList";
import {useEffect, useRef, useState} from "react";
import axios from "axios";
import React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import useWindowDimensions from "../util/useWindowDimensions";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AppsIcon from '@mui/icons-material/Apps';
import ListIcon from '@mui/icons-material/List';
import {ToggleButton, ToggleButtonGroup} from "@mui/material";
import ReactDOM from "react-dom";
import EventListByTime from "../EventList/EventListByTime";

export interface IEventListTabsProps {
  events: string[],
  closingDate: string
}




function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const EventListTabs = (props: IEventListTabsProps) => {
  const [eventDataList, setEventDataList] = useState<IEventData[]>([]);
  const [value, setValue] = React.useState(0);
  const {height, width} = useWindowDimensions();
  const [view, setView] = React.useState('grid');
  const rootRef = useRef<HTMLDivElement>(null);

  const handleViewChange = (event: any, newAlignment: React.SetStateAction<string>) => {
    if (newAlignment !== null) {
      setView(newAlignment);
    }
  };

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  const scrollToRootRef  = () => {
    let node = ReactDOM.findDOMNode(rootRef.current) as Element;
    node.scrollIntoView({block: 'start', behavior: 'smooth'});
  }

  const setCurrentPlace = (index: number) => {
    setValue(index);
    setView('list');
    scrollToRootRef();
  };

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    var getUrl = window.location;
    var baseURL = getUrl.protocol + "//" + getUrl.host;
    if (baseURL == 'http://localhost:3000') {
      baseURL = 'https://buxliest.local.computer/';
    }
    axios.get(baseURL + "/" + "/bux-api/bux-event/event-data-all/" + props.events.join('-') + "?_format=json", {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((result) => {
        setEventDataList(result.data);
      })
      .catch(error => {
        if (error.response) {
          console.log(error.responderEnd);
        }
      });
  }

  const orientation = width >= 768 ? "vertical" : "horizontal";
  return (
    <div className="flex flex-col w-full">
      <div ref={rootRef}></div>
      <ToggleButtonGroup
        value={view}
        exclusive
        onChange={handleViewChange}
        aria-label="text alignment"
        className="mb-16 mx-auto"
        color="primary"
      >
        <ToggleButton value="grid">
          <AppsIcon/> <span className="px-2 normal-case">Orte</span>
        </ToggleButton>
        <ToggleButton value="list">
          <ListIcon/> <span className="px-2 normal-case">Lesungen</span>
        </ToggleButton>
        <ToggleButton value="overview">
          <AccessTimeIcon/> <span className="px-2 normal-case">Übersicht</span>
        </ToggleButton>
      </ToggleButtonGroup>
      {view == 'grid' && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 items-start">
          {eventDataList.map((item, index) =>
            <div className="w-full flex flex-col text-center bg-secondary-50 self-stretch p-2 md:pt-6 rounded-sm cursor-pointer" onClick={() => { setCurrentPlace(index) }}>
              {item.place?.images?.length > 0 &&
              <Box className="flex align-center">
                <img className="rounded-sm overflow-hidden" src={item.place?.images[0].thumbnail.url}/>
              </Box>
              }
              <p className="text-xl text-primary-800 my-2 flex-1">{item.place?.title}</p>
            </div>
          )}
        </div>
      )}
      {view == 'list' && (
        <div className="md:flex md:w-full">
          <Tabs
            orientation={orientation}
            variant="scrollable"
            value={value}
            onChange={handleChange}
            aria-label="Vertical tabs example"
            className="md:w-[200px] md:min-w-[200px] border-r border-gray-300"
          >
            {eventDataList.map((item, index) => {
              return (
                <Tab label={<span className="normal-case align-left">{item.place?.title}</span>} {...a11yProps(index)} />
              );
            })
            }
          </Tabs>
          {eventDataList.map((item, index) =>
            <div
              role="tabpanel"
              hidden={value !== index}
              id={`vertical-tabpanel-${index}`}
              aria-labelledby={`vertical-tab-${index}`}
            >
              {value === index && (
                <Box className="py-12 md:py-0 md: px:12">
                  <EventList event={item.id} closingDate={props.closingDate}></EventList>
                </Box>
              )}
            </div>
          )}
        </div>
      )}
      {view == 'overview' && (
        <EventListByTime></EventListByTime>
        )}
    </div>
  );
}

export default EventListTabs;
